import { render } from "./WorkAreaDetailsPageDemand.vue?vue&type=template&id=ad174116"
import script from "./WorkAreaDetailsPageDemand.vue?vue&type=script&lang=ts"
export * from "./WorkAreaDetailsPageDemand.vue?vue&type=script&lang=ts"
script.render = render

export default script